import {
    IExpedition,
    IExpeditionDay,
    IExpeditionAutoControl,
    IExpeditionNotification,
    ISlot,
} from "@/models";

interface IExpeditionState {
    expeditionStartSlot: ISlot;
    expeditionEndSlot: ISlot;
    expeditionDay: IExpeditionDay;
    notifications: IExpeditionNotification[];
    selectedExpedition: IExpedition;
    picturesAutoControl: string[];
    picturesEndLoad: string[];
    expeditionAutoControl: IExpeditionAutoControl;
    selectedNotification: IExpeditionNotification;
}

const initialState: IExpeditionState = {
    expeditionStartSlot: {
        slotId: 21,
        startTime: "05:00:00",
        endTime: "05:15:00",
    },
    expeditionEndSlot: {
        slotId: 85,
        startTime: "21:00:00",
        endTime: "21:15:00",
    },
    expeditionDay: {
        day: "",
        docks: [],
    },
    notifications: [],
    selectedExpedition: null,
    picturesAutoControl: [],
    picturesEndLoad: [],
    expeditionAutoControl: null,
    selectedNotification: null,
};

export { IExpeditionState, initialState };
